var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDeptreact = function SvgDeptreact(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 80 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#686868",
    d: "M59.02 27.53h4V16.4H67V13H55.05v3.41h3.97v11.12Zm-13.2-7.87v-3.53h2.3c1.46 0 2.19.6 2.19 1.77 0 1.16-.73 1.76-2.2 1.76h-2.28Zm-3.97 7.87h4v-4.74h2.4c3.59 0 5.97-1.55 5.97-4.9 0-3.34-2.42-4.89-5.98-4.89h-6.39v14.53Zm-13.76 0h10.9v-3.25h-6.9V21.8h6.84v-3.13h-6.84v-2.43H39V13H28.1v14.53ZM16 24.15v-7.77h1.27c2.8 0 4.54 1.01 4.54 3.88 0 2.88-1.71 3.89-4.54 3.89H16Zm-4 3.38h5.25c4.96 0 8.55-1.96 8.55-7.27-.03-5.3-3.63-7.26-8.55-7.26H12v14.53Z"
  })));
};
export default SvgDeptreact;